module.exports = __webpack_public_path__ + "img/graphic-2.43d2e6e3.png";